import { Button, Checkbox } from "@material-ui/core";
import axios from "axios";
import React, { useState, useEffect } from "react";
import useConfirm from "../../components/Control/useConfirm";
import Styled from "styled-components";
import Publish from "@material-ui/icons/Publish";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Delete from "@material-ui/icons/Delete";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";

const Table = Styled.table`
    margin-bottom: 1rem;
    width:98%;
    margin:auto;
    th{
        font-size: 12px;
		    font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        font-weight:bold;
        p{
          margin:0;
        }
    }
    td{
        font-size: 12px;
        border: 1px solid black;
        padding: 0.3rem;
        p{
          margin:0
        }
        b{
		    font-family:"Roboto",sans-serif;
          margin:0,
        }
    }
`;

const PublishAnnexure = ({ annexureType, setIsPublishModal, id }) => {
    const [data, setData] = useState([]);
    const [controlData, setControlData] = useState({
        processes: [],
    });
    const [pfdData, setPfdData] = useState({
        processes: [],
    });
    // latest revision of every special process, of every category, as one flat
    // list, they are listed inside the control plan and the pfd section because
    // a picked special process is published into both documents
    const [specialProcessData, setSpecialProcessData] = useState([]);
    const [expandedSpecialProcesses, setExpandedSpecialProcesses] = useState({});
    const [render, setRender] = useState(false);
    const [DialogUpdate, confirmUpdate] = useConfirm(
        "UPDATE STATUS",
        "Are you sure you want to update this?",
    );
    const [file, setFile] = useState(null);
    useEffect(() => {
        if (id) {
            axios
                .get(`/api/getAnnexureById/${id}`)
                .then((res) => {
                    if (res.data) {
                        res.data.isSubmittedNo = "2";
                        setData([res.data]);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [id]);
    useEffect(() => {
        if (id) {
            axios
                .get(`/api/getMasterControlPlan?annexureType=${annexureType}`)
                .then((res) => {
                    if (res.data) {
                        setControlData(res.data);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [id]);
    useEffect(() => {
        if (id) {
            axios
                .get(`/api/getMasterPfdPlan?annexureType=${annexureType}`)
                .then((res) => {
                    if (res.data) {
                        setPfdData(res.data);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [id]);
    useEffect(() => {
        if (id) {
            axios
                .get(`/api/specialProcess/latestRevisions`)
                .then((res) => {
                    if (res.data) {
                        setSpecialProcessData(res.data);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [id]);
    const publishAnnexure = async () => {
        if (!file) {
            return alert("please choose image!");
        }
        let isConfirm = await confirmUpdate();
        if (isConfirm) {
            const formData = new FormData();
            formData.append("sop_img", file);
            await axios
                .put(`/api/update/annexure/${id}`, formData)
                .then((res) => {
                    if (res.data) {
                        axios
                            .post(`/api/publish/annexure`, {
                                parts: data,
                                controlData,
                                pfdData: pfdData,
                                specialProcessData,
                            })
                            .then((res) => {
                                if (res.data.status === "failed") {
                                    alert("unable to publish because part name not found");
                                }
                                if (res.data.status === "success") {
                                    alert("Status Change successfully");
                                    setFile(null);
                                    setIsPublishModal(false);
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                })
                .catch((err) => console.log(err));
        }
    };
    const handleChange = (e, item, changeType) => {
        const data = {
            pfd: pfdData,
            controlplan: controlData,
        };
        item.isHide = e.target.checked;

        if (data[changeType].processes.length === 0)
            return setRender((prev) => !prev);
        data[changeType].processes.forEach((element) => {
            if (element.process_no === item.process_no) {
                console.log("true");
                element.isHide = e.target.checked;
            }
        });
        setRender((prev) => !prev);
    };
    // the same revision object is rendered in the control plan and in the pfd
    // section, so flagging it keeps both sections in sync on its own
    const handleSpecialProcessChange = (e, revision) => {
        revision.isHide = e.target.checked;
        setRender((prev) => !prev);
    };
    const toggleSpecialProcessList = (section, categoryKey) => {
        const expansionKey = `${section}:${categoryKey}`;
        setExpandedSpecialProcesses((prev) => ({
            ...prev,
            [expansionKey]: !prev[expansionKey],
        }));
    };
    const specialProcessGroups = specialProcessData.reduce((groups, revision) => {
        const category = revision.category_id;
        const categoryKey = category?._id || category || "uncategorized";
        const categoryName = category?.category_name || "Uncategorized";
        if (!groups[categoryKey]) {
            groups[categoryKey] = { categoryKey, categoryName, revisions: [] };
        }
        groups[categoryKey].revisions.push(revision);
        return groups;
    }, {});
    // the rows are rendered twice inside the same table, so the section is part
    // of the key to keep them unique
    const specialProcessRows = (section, revisions, offset) =>
        revisions.map((revision, index) => {
            const process = revision.processes?.[0];
            const revisionId = revision._id || index;
            return (
                <tr key={`${section}-${revisionId}`}>
                    <td align="center">{offset + index + 1}</td>
                    <td align="center">
                        {process?.process_name ||
                            revision.special_process_id?.process_name}
                    </td>
                    <td align="center">
                        {process?.process_no || revision.special_process_id?.process_no}
                    </td>
                    <td align="center">
                        <Checkbox
                            checked={Boolean(revision.isHide)}
                            onChange={(e) => handleSpecialProcessChange(e, revision)}
                        />
                    </td>
                </tr>
            );
        });
    const specialProcessSection = (section, offset) => {
        let rowOffset = offset;
        return Object.values(specialProcessGroups).map((group) => {
            const expansionKey = `${section}:${group.categoryKey}`;
            const isExpanded = Boolean(expandedSpecialProcesses[expansionKey]);
            const groupOffset = rowOffset;
            rowOffset += group.revisions.length;
            return (
                <React.Fragment key={expansionKey}>
                    <tr>
                        <th colSpan={4} style={{ textAlign: "left" }}>
                            <Button
                                size="small"
                                onClick={() =>
                                    toggleSpecialProcessList(section, group.categoryKey)
                                }
                                startIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
                                aria-expanded={isExpanded}
                            >
                                {isExpanded ? "Hide" : "Show"} {group.categoryName}
                                {` Special Processes (${group.revisions.length})`}
                            </Button>
                        </th>
                    </tr>
                    {isExpanded &&
                        specialProcessRows(section, group.revisions, groupOffset)}
                </React.Fragment>
            );
        });
    };
    const handleImagePdf = (e) => {
        setFile(e.target.files[0]);
        e.target.value = "";
    };
    const removeFiles = () => {
        const values = { ...data };
        values.sop_img = null;
        setFile(null);
        setData(values);
    };
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "1.2rem",
                    marginBottom: "1.5rem",
                }}
            >
                <input
                    id="contained-button-file"
                    type="file"
                    name="pcs_imageOrPdf"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={handleImagePdf}
                    hidden
                />
                <label
                    htmlFor="contained-button-file"
                    style={{
                        marginBottom: "0",
                    }}
                >
                    <Button variant="outlined" component="span" color="secondary">
                        <CloudUpload style={{ marginRight: "1rem" }} />
                        Upload Picture
                    </Button>
                </label>
                {file && (
                    <Button
                        variant="outlined"
                        type="button"
                        color="primary"
                        style={{
                            marginLeft: "0.6rem",
                        }}
                        onClick={removeFiles}
                        startIcon={<Delete />}
                    >
                        REMOVE
                    </Button>
                )}
            </div>
            <Table>
                <tbody>
                    <tr style={{ fontWeight: "bold" }}>
                        <td style={{ border: "1px solid black" }} align="center">
                            #
                        </td>
                        <td style={{ border: "1px solid black" }} align="center">
                            Process Name.
                        </td>
                        <td style={{ border: "1px solid black" }} align="center">
                            Process Number
                        </td>
                        <td style={{ border: "1px solid black" }} align="center">
                            Action
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={4}>CONTROL PLAN</th>
                    </tr>
                    {controlData.processes.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <tr>
                                    <td align="center" style={{ border: "1px solid black" }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ border: "1px solid black" }} align="center">
                                        {item.process_name}
                                    </td>
                                    <td style={{ border: "1px solid black" }} align="center">
                                        {item.process_no}
                                    </td>
                                    <td style={{ border: "1px solid black" }} align="center">
                                        <Checkbox
                                            checked={item.isHide || ""}
                                            onClick={(e) => {
                                                handleChange(e, item, "pfd");
                                            }}
                                        />
                                    </td>
                                </tr>
                            </React.Fragment>
                        );
                    })}
                    {specialProcessSection("controlplan", controlData.processes.length)}
                    <tr>
                        <th colSpan={4}>PFD</th>
                    </tr>
                    {pfdData.processes.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <tr>
                                    <td align="center" style={{ border: "1px solid black" }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ border: "1px solid black" }} align="center">
                                        {item.process_name}
                                    </td>
                                    <td style={{ border: "1px solid black" }} align="center">
                                        {item.process_no}
                                    </td>
                                    <td style={{ border: "1px solid black" }} align="center">
                                        <Checkbox
                                            checked={item.isHide || ""}
                                            onClick={(e) => {
                                                handleChange(e, item, "controlplan");
                                            }}
                                        />
                                    </td>
                                </tr>
                            </React.Fragment>
                        );
                    })}
                    {specialProcessSection("pfd", pfdData.processes.length)}
                </tbody>
            </Table>
            <DialogUpdate />
            <div
                className="btn_save"
                style={{
                    position: "absolute",
                    right: "150px",
                    top: "9px",
                }}
            >
                <Button
                    type="submit"
                    variant="outlined"
                    color="white"
                    size="large"
                    style={{ color: "#e9e9e9" }}
                    startIcon={<Publish />}
                    onClick={() => publishAnnexure()}
                >
                    Publish
                </Button>
            </div>
        </div>
    );
};

export default PublishAnnexure;
